import './index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
const rootEl = document.getElementById('root');
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<BrowserRouter data-id="element-197" data-mp="218mohd78tx4r">
      <App data-id="element-198" data-mp="21ck77xpwsmo4" />
    </BrowserRouter>);
}